const PhoneMockup = ({ className = "" }) => (
  <div
    data-testid="phone-mockup"
    className={`relative w-[210px] rounded-[2rem] border border-[#C19D60]/30 bg-[#0a0a0c] p-2 shadow-[0_50px_100px_-30px_rgba(0,0,0,0.95)] ${className}`}
  >
    <div className="overflow-hidden rounded-[1.6rem] bg-[#0F0F11]">
      <div className="mx-auto mt-2 h-5 w-20 rounded-full bg-black" />
      <div className="px-4 pb-6 pt-4">
        <div className="flex items-center justify-center gap-2 border-b border-[#C19D60]/20 pb-3">
          <img src="/assets/recensio-logo.png" alt="" className="h-4 w-auto opacity-90" />
        </div>
        <p className="mt-3 text-center text-[8px] uppercase tracking-[0.3em] text-[#C19D60]">Menu digitale</p>
        <div className="mt-3 flex justify-center gap-1.5">
          {["Antipasti", "Primi", "Dolci"].map((c, i) => (
            <span
              key={c}
              className={`rounded-full border px-2 py-1 text-[7px] tracking-wider ${
                i === 0 ? "border-[#C19D60]/60 text-[#E5CAA4]" : "border-white/10 text-[#8a8a8a]"
              }`}
            >
              {c}
            </span>
          ))}
        </div>
        <div className="mt-4 space-y-3">
          {[
            ["Crudo di branzino", "18"],
            ["Tagliatella al tartufo", "24"],
            ["Risotto allo zafferano", "21"],
            ["Filetto di manzo", "32"],
          ].map(([dish, price]) => (
            <div key={dish} className="flex items-baseline justify-between gap-2">
              <span className="font-display text-[11px] italic text-[#F8F5F0]/90">{dish}</span>
              <span className="flex-1 border-b border-dotted border-white/15" />
              <span className="text-[10px] text-[#C19D60]">{price}€</span>
            </div>
          ))}
        </div>
        <div className="mt-4 overflow-hidden rounded-md">
          <img src="/assets/food.jpg" alt="Piatto" className="h-16 w-full object-cover opacity-90" />
        </div>
      </div>
    </div>
  </div>
);

export default PhoneMockup;
